module.exports = __webpack_public_path__ + "img/filesIcon.18c76600.png";